const mapToMemberRoles = (rolesList, manageAll) => {
  const filteredRoles = rolesList?.filter((r) => {
    return manageAll ? r != null : !r.isSuperRole;
  });

  return filteredRoles;
};

export default mapToMemberRoles;
